export const ADVISOR_ID_KEY = 'am_agent_id';
export const LEAD_ID_KEY = 'am_lead_id';
export const LEAD_STRATEGY_ID_KEY = 'am_lead_strategy_id';
export const ABOUT_YOU_KEY = 'am_about_you';
export const LEAD_APP_STATE = 'am_lead_app_state';
// goal
export const GOAL_KEY = 'am_goal';
export const GOAL_ID_KEY = 'am_goal_id';
// external user key
export const EXTERNAL_USER_ID = 'am_external_user_id';

